/**
 * Normalizes usage and quota to integers with min of 0 and max of quota
 * Returns null if input is invalid
 */
export const normalizeRecapsUsage = (input) => {
  const { quota, usage, credits } = input || {}

  if (quota == null || usage == null || credits == null) {
    return null
  }

  const recapsQuota = Math.floor(quota)
  const usedRecaps = Math.max(0, Math.min(recapsQuota, Math.floor(usage - credits)))

  return { usedRecaps, recapsQuota }
}
